import { Namespace } from "@cirrus/fe-lib"

import { entities } from "../_params.js"

export const Skins = {
  domain: Namespace.domain(entities, "Skins"),
}
